import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

import {formatEmails} from './helpers';
import {dateTimeFormats} from 'helpers/constants';
import PrintableFullReport from '../../components/printableFullReport.jsx';

let columns;
let tableColumns;

const getElementsLabels = (formatMessage) => {
  columns = [
    {name: formatMessage('general.total.accounts'), key: 'totalAccounts'},
    {name: formatMessage('general.total.systems'), key: 'totalSystems'},
    {name: formatMessage('general.total.pools'), key: 'totalPools'},
    {name: formatMessage('general.in.ground.pools'), key: 'inGroundPools'},
    {name: formatMessage('general.above.ground.pools'), key: 'aboveGroundPools'},
    {name: formatMessage('general.splasher.pools'), key: 'splasherPools'},
    {name: formatMessage('general.swim.spas'), key: 'swimSpas'},
    {name: formatMessage('general.spas'), key: 'spas'},
    {name: formatMessage('general.total.maintenance'), key: 'systemsOnMaintenance'},
  ];

  tableColumns = [
    {name: formatMessage('general.primary.contact'), key: 'FullName'},
    {name: formatMessage('general.primary.phone'), key: 'HomePhone'},
    {name: formatMessage('general.email.address'), key: 'Email'},
    {
      name: formatMessage('general.last.analysis'),
      key: 'PrevAnalysisDate',
      format: i => moment(i, 'MMM D YYYY  h:mmA').format(dateTimeFormats.numeralDate),
    },
    {
      name: formatMessage('general.next.analysis'),
      key: 'NextAnalysisDate',
      format: i => moment(i, 'MMM D YYYY  h:mmA').format(dateTimeFormats.numeralDate),
    },
    {name: formatMessage('general.water.tester'), key: 'WaterTester'},
    {name: formatMessage('general.system.email'), key: 'SystemEmail'},
  ];
};

const PastDuePrintReport = ({start, end, report, summary, formatMessage}) => {
  report.forEach(element => element.SystemEmail = formatEmails(element, formatMessage), this);

  getElementsLabels(formatMessage);

  return <PrintableFullReport
    end={end.format(dateTimeFormats.numeralDate)}
    endLabel={formatMessage('general.end.date')}
    formatMessage={formatMessage}
    start={start.format(dateTimeFormats.numeralDate)}
    startLabel={formatMessage('general.start.date')}
    summaryColumns={columns}
    summaryData={summary}
    tableColumns={tableColumns}
    tableData={report}
    title={formatMessage('reports.followups.pastdue.analysis')}
  />;
};

PastDuePrintReport.propTypes = {
  start: PropTypes.instanceOf(moment).isRequired,
  end: PropTypes.instanceOf(moment).isRequired,
};

export default PastDuePrintReport;
